import { InjectionToken } from '@angular/core';

export enum AppsEnum {
    CLIENT = "CLIENT",
    SUPPORT = "SUPPORT",
}

export const APP_TOKEN = new InjectionToken<AppsEnum>('APP');
